// One menu entry per "refresh this prompt's output" use case. Each is
// mapped to the exact tag column(s) the moderator wants re-extracted.
// Add new entries here as new prompt-tunable fields appear; the
// REANALYZABLE_FIELDS allow-list on the server already covers every
// option below — keep them in sync if either list changes.
//
// An option may also set `rebuildChunks: true` to (re)build the
// semantic-chunk lane (km_story_chunks) for each processed story — used
// to backfill chunks across the corpus / refresh them after a chunk-prompt
// change. It's opt-in because it costs extra embedding writes per story.
// `fields` must stay non-empty (server + client both reject empty), so a
// chunk rebuild is paired with re-extracting `search_summary` (which leads
// the chunk lane) — refreshing the whole "search representation" together.
//
// Both ModerationDashboard (batch, all approved stories) and
// StoryViewPage (single story, moderator action) import this so the
// available actions never drift between the two surfaces.

export const REANALYZE_OPTIONS = [
  { label: 'Guna arc',         fields: ['guna_arc'] },
  { label: 'Life areas',       fields: ['life_areas'] },
  { label: 'Inner knots',      fields: ['inner_knots'] },
  { label: 'Obstacles',        fields: ['obstacles'] },
  { label: 'Mental states',    fields: ['mental_states'] },
  { label: 'Inner qualities',  fields: ['inner_qualities'] },
  { label: 'Practices',        fields: ['practice_ids', 'practice_freetext', 'tradition'] },
  { label: 'Time period',      fields: ['time_period'] },
  { label: 'Title',            fields: ['title'] },
  { label: 'Highlight',        fields: ['highlight'] },
  { label: 'Search summary',   fields: ['search_summary'] },
  { label: 'Semantic chunks',  fields: ['search_summary'], rebuildChunks: true },
];
